export const truncateText = (inputStr: string, showStr = 30): string => {
  if (inputStr.length <= showStr) return inputStr;
  return inputStr.substring(0, showStr) + '...';
};
export function toCapitalCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const truncateText_v2 = (inputStr: string, showStr = 20): string => {
  if (inputStr.length <= showStr) return inputStr;

  const ellipsis = '...';
  const keep = showStr - ellipsis.length;

  const front = Math.ceil(keep / 2);
  const back = Math.floor(keep / 2);

  return (
    inputStr.substring(0, front) +
    ellipsis +
    inputStr.substring(inputStr.length - back)
  );
};

export const cleanCommas = (input: string) => {
  const cleaned = String(input).replace(/,/g, '');
  return cleaned;
};

export const toInt = (v: unknown, fallback = 0) => {
  const n = typeof v === 'string' ? parseInt(v.trim(), 10) : Number(v);
  return Number.isFinite(n) ? n : fallback;
};
export const toFloat = (v: unknown, fallback = 0) => {
  const n = typeof v === 'string' ? parseFloat(v.trim()) : Number(v);
  return Number.isFinite(n) ? n : fallback;
};

export const toStr = (v: unknown): string => (v ?? '').toString().trim();

export const toNum = (v: unknown): number => {
  if (v === null || v === undefined || v === '') return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

export const idNumToStrOrEmpty = (n: number | null | undefined): string =>
  n && n > 0 ? String(n) : '';
